import type { AddProfilePicture } from '../types/SharedActions';
import { updateLocalStorage } from './updateLocalStorage';

export const addProfileImage = (value: AddProfilePicture['value']): void => {
  const { url, ...rest } = value;

  updateLocalStorage(`fileAttachments.profileImage.url`, url);

  updateLocalStorage(`profileImage`, {
    ...rest,
    delete: false,
  });
};
